import { render, staticRenderFns } from "./BEOProduct.vue?vue&type=template&id=3232e79d&"
import script from "./BEOProduct.vue?vue&type=script&lang=js&"
export * from "./BEOProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports